(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const backToTopButton = document.querySelector('[data-collection-back-to-top]');
      const toggleBackToTopButton = () => {
        if (!backToTopButton) return;
        const shouldShow = window.scrollY > 320;
        backToTopButton.classList.toggle('is-visible', shouldShow);
      };

      if (backToTopButton) {
        backToTopButton.addEventListener('click', () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
        toggleBackToTopButton();
        window.addEventListener('scroll', toggleBackToTopButton, { passive: true });
      }

      const url = new URL(window.location.href);
      if (url.hash) {
        const hash = url.hash;
        if (hash === '#MainContent' || hash === '#ResultsList') {
          window.scrollTo({ top: 0, behavior: 'instant' });
          return;
        }

        const target = document.getElementById(hash.slice(1));
        if (target) {
          target.scrollIntoView({ behavior: 'instant' });
        }
      }
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
